import $ from 'jquery'

function showToast(msg, callback) {
  //提示
  // eslint-disable-next-line no-undef
  layer.open({
    content: msg
    , skin: 'msg'
    , time: 2 //2秒后自动关闭
    , end: function () {
      if (callback) {
        callback()
      }
    }
  });
}

function postApi(api, data, callback) {
  $.ajax(api, {
    method: 'POST',
    dataType: 'json',
    data: data,
    success: function (data) {
      if (callback) {
        callback(data)
      }
    }
  })
}

function getApi(api, callback) {
  $.ajax(api, {
    method: 'GET',
    dataType: 'json',
    success: function (data) {
      if (callback) {
        callback(data)
      }
    }
  })
}

function isLogin(that, boxCode, callback) {
  const memberInfo = localStorage.getItem("box_code_member_info");
  let expireAt = localStorage.getItem("box_code_member_expireat");
  if (memberInfo && expireAt) {
    expireAt = parseInt(expireAt)
    const now = new Date().getTime();
    if (now > expireAt) {
      that.$router.push({
        path: "/login",
        query: {
          box_code: boxCode,
        },
      });
    } else {
      if (callback) {
        callback()
      }
    }
  } else {
    that.$router.push({
      path: "/login",
      query: {
        box_code: boxCode,
      },
    });
  }
}

export {
  showToast,
  postApi,
  getApi,
  isLogin
}
